import { create } from 'zustand';
import { apiClient } from '../services/api';

export interface CampaignData {
  id: string;
  name: string;
  slug: string;
  status: string;
  description: string;
  productName: string;
  productDescription: string;
  productImage: string;
  initialImageUrl: string;
  startDate: string;
  endDate: string;
  regulationPdfUrl?: string;
  faqPdfUrl?: string;
  stores: any[];
}

type CampaignStatus = 'idle' | 'loading' | 'ready' | 'not-found' | 'error';

interface CampaignState {
  campaign: CampaignData | null;
  status: CampaignStatus;
  error: string | null;

  loadCampaignBySlug: (slug: string) => Promise<void>;
  loadActiveCampaign: () => Promise<CampaignData | null>;
  reset: () => void;
}

export const useCampaignStore = create<CampaignState>((set) => ({
  campaign: null,
  status: 'idle',
  error: null,

  loadCampaignBySlug: async (slug: string) => {
    set({ status: 'loading', error: null });
    try {
      const { data } = await apiClient.get<CampaignData>(`/customer/campaigns/slug/${slug}`);
      set({ campaign: data, status: 'ready' });
    } catch (err: any) {
      if (err.response?.status === 404) {
        set({ status: 'not-found', error: 'Campanha não encontrada ou encerrada.' });
      } else {
        set({ status: 'error', error: 'Erro ao carregar campanha. Tente novamente.' });
      }
    }
  },

  loadActiveCampaign: async () => {
    try {
      const { data } = await apiClient.get<CampaignData>('/customer/campaigns/active');
      return data;
    } catch {
      return null;
    }
  },

  reset: () => set({ campaign: null, status: 'idle', error: null }),
}));
